import type { AgeGroupDTO } from '@ui/shared/util-api';

export const getAgeGroupLabelForAgeGroupDTO = (ageGroup: AgeGroupDTO): string =>
    `${ ageGroup.name } (${ ageGroup.age_min } - ${ ageGroup.age_max })`;
